import { ref } from "vue";
import { useMapStore } from "@/store/Map/map-store";
import { useLK } from "@/controllerLK/LKstore";
import { useNotificationsStore } from "@/store/notifications";
import { t } from "@/controllerLK/AvalLocalization";

export function useMapUpload() {
  const LKStore = useLK();
  const notificationStore = useNotificationsStore();
  const mapStore = useMapStore();

  // Список найденных карт
  const mapList = ref([]);

  // Значение поисковой строки
  const mapSearchString = ref("");

  // Поиск карты
  const searchMap = async (mapName) => {
    mapSearchString.value = mapName;

    if (mapName.trim().length < 1) {
      mapList.value = [];
    } else {
      mapList.value = await mapStore.searchRegion(mapName);
    }
  };

  // Добавление новой карты в проект
  const createMap = async (map, callbacks = {}) => {
    const { onStart, onSuccess, onError } = callbacks;

    if (onStart) onStart();

    try {
      const mapData = await mapStore.createMap(LKStore.project.id, map.id, map.name);
      notificationStore.createNotify(t("no_map_view.toast.success"), "success");
      if (onSuccess) onSuccess(mapData);
      return mapData;
    } catch (error) {
      notificationStore.createNotify(t("no_map_view.toast.error"), "error");
      if (onError) onError(error);
      throw error;
    }
  };

  // Валидация файла
  const validateFile = (file) => {
    const MAX_SIZE = 10 * 1024 * 1024; // 10 МБ
    const validExtensions = [".geojson", ".json"];

    // Проверка расширения
    const fileExtension = file.name.toLowerCase().slice(file.name.lastIndexOf("."));
    if (!validExtensions.includes(fileExtension)) {
      notificationStore.createNotify(t("no_map_view.toast.warning.format"), "error");
      return false;
    }

    // Проверка размера
    if (file.size > MAX_SIZE) {
      notificationStore.createNotify(t("no_map_view.toast.format.size"), "error");
      return false;
    }

    return true;
  };

  // Обработка загрузки файла
  const uploadMap = async (file, callbacks = {}) => {
    const { onStart, onSuccess, onError } = callbacks;

    if (!validateFile(file)) {
      return;
    }

    if (onStart) onStart();

    try {
      const mapData = await mapStore.uploadMap(LKStore.project.id, file);
      notificationStore.createNotify(t("no_map_view.toast.success"), "success");
      if (onSuccess) onSuccess(mapData);
      return mapData;
    } catch (error) {
      notificationStore.createNotify(t("no_map_view.toast.error"), "error");
      if (onError) onError(error);
      throw error;
    }
  };

  return {
    mapList,
    mapSearchString,
    searchMap,
    createMap,
    uploadMap,
    validateFile
  };
}
